import { render } from "./banSound.vue?vue&type=template&id=49ca243e"
import script from "./banSound.vue?vue&type=script&lang=js"
export * from "./banSound.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__